var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.0925 8.71299L21.2475 22.2955H18.945L8.79 8.71299H11.0925ZM30 15.5005C30 23.788 23.2875 30.5005 15 30.5005C6.7125 30.5005 0 23.788 0 15.5005C0 7.21299 6.7125 0.500488 15 0.500488C23.2875 0.500488 30 7.21299 30 15.5005ZM23.415 23.3755L16.5525 14.203L22.635 7.62549H21.165L15.8925 13.318L11.6325 7.62549H6.6225L13.1175 16.3105L6.5775 23.3755H8.0475L13.77 17.188L18.3975 23.3755H23.4075H23.415Z","fill":"currentColor"}));
}

Twitter.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Twitter;

Twitter.default = Twitter;
